<template>
    <div>
        <el-dropdown placement="top-start" trigger="hover" ref="qMsgDropdown">
            <span class="el-dropdown-link">
                <!-- <img class="icon pointer" src="@/assets/qReply.png" alt=""></img> -->
                <img class="item_img w-24 h-24" v-if="isTranslating" src="@/assets/loading.gif" alt=""
                    style="opacity: 0.7;">
                <img class="item_img w-24 h-24" v-else-if="isTranslated && !userModified" src="@/assets/icon/yFy.png"
                    alt="" @click="lmyFir()">
                <img class="item_img w-24 h-24" v-else src="@/assets/icon/nFy.png" alt="" @click="lmyFir()">
            </span>
            <el-dropdown-menu slot="dropdown" class="stickersClass" style="width: 60vw;">
                <div class="BBox">
                    <div class="title">
                        推荐
                        <template v-if="currentLanguage">(当前目标语言：{{ currentLanguage }})</template>
                    </div>
                    <div>
                        <div style="display: flex; flex-wrap: wrap;align-items: center;">
                            <div class="commonBox pointer" v-for="(v, i) in firstTenItems" :key="i"
                                @click="!isTranslating && lmyFir(v)" :class="{ 'disabled': isTranslating }">
                                {{ v.name }}
                            </div>
                        </div>
                    </div>
                    <div class="title">
                        其他
                    </div>
                    <div>
                        <div style="display: flex; flex-wrap: wrap;align-items: center;">
                            <div class="commonBox pointer" v-for="(v, i) in fromTenthToEnd" :key="i"
                                @click="!isTranslating && lmyFir(v)" :class="{ 'disabled': isTranslating }">
                                {{ v.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { union } from 'lodash';
import language from '../utils/language'
import { generateYoudaoSignedParams, translate } from '@/api/youdaoSign';
export default {
    props: {
        message: {
            type: String,
            default: ''
        },

    },
    components: {
    },
    computed: {
        firstTenItems() {
            return this.languageData?.languageList.slice(0, 20); // 返回前10个元素
        },
        fromTenthToEnd() {
            return this.languageData?.languageList.slice(19); // 返回从第10个到末尾
        }
    },
    data() {
        return {
            isTranslated: false,
            languageData: language,
            translatedBefore: '',
            currentLanguage: '',
            isTranslating: false,
            userModified: false, // 用户是否手动修改了翻译结果
            lastTranslation: '' // 记录最后一次翻译结果
        }
    },
    created() {
        console.log(this.languageData, language)
        if (localStorage.getItem('language')) {
            const list = this.languageData?.languageList;
            console.log(list)
            const foundItem = list.find(item => item.code.includes(localStorage.getItem('language')));
            console.log(foundItem, 'foundItem')
            this.currentLanguage = foundItem.name
            console.log(this.currentLanguage, 'this.currentLanguage')
        }
    },
    mounted() {
        console.log(this.languageData, language)
    },
    watch: {
        // 监听父组件传入的message变化，检测用户是否手动修改了翻译结果
        message: {
            handler(newVal, oldVal) {
                // 如果当前处于翻译状态，且新值与上次翻译结果不同，说明用户手动修改了
                if (this.isTranslated && this.lastTranslation && newVal !== this.lastTranslation) {
                    this.userModified = true;
                    // 重置翻译状态，不允许再切换回原文
                    this.isTranslated = false;
                }
            },
            immediate: false
        }
    },
    methods: {
        lmyFir(v) {
            console.log(this.message, 'message')

            // 如果没有消息内容
            if (!this.message) {
                if (v) {
                    // 点击语言列表：设置目标语言
                    localStorage.setItem('language', v.code)
                    this.$message.success('目标翻译语言设置成功')
                    this.currentLanguage = v.name
                    return
                } else {
                    this.$message.error('请输入内容')
                    return
                }
            }

            // 如果有消息内容
            if (v) {
                // 点击语言列表：修改翻译语言并立即翻译
                localStorage.setItem('language', v.code)
                this.currentLanguage = v.name
                this.handleTranslate(this.message, v.code)
            } else {
                // 点击翻译图标：切换翻译状态
                if (this.isTranslated && !this.userModified) {
                    // 当前已翻译且用户未修改，取消翻译
                    this.isTranslated = false
                    this.userModified = false
                    this.$emit('checkQMsg', this.translatedBefore)
                } else {
                    // 当前未翻译或用户已修改，进行翻译
                    const targetLang = localStorage.getItem('language') || 'zh-CHS'
                    this.handleTranslate(this.message, targetLang)
                }
            }
        },
        // 翻译
        async handleTranslate(v, toTra) {
            console.log(v, toTra)
            let toLang = '';
            if (toTra) {
                toLang = toTra
            } else {
                toLang = 'zh'
            }

            this.isTranslating = true

            try {
                let translation = await translate(
                    v,
                    'auto',
                    toLang
                )
                console.log(translation, toLang)
                if (translation && toLang === 'en') {
                    translation = translation.charAt(0).toUpperCase()
                        + translation.slice(1).toLowerCase();
                }
                this.$emit('checkQMsg', translation)
                this.isTranslated = true
                this.translatedBefore = v
                this.lastTranslation = translation // 记录翻译结果
                this.userModified = false // 重置用户修改状态
            } catch (err) {
                this.$message.error(err.message)
            } finally {
                this.isTranslating = false
            }

        },
        detectLanguage(text) {
            if (!text || !text.trim()) return 'unknown';

            // 定义各语言的正则表达式
            const languagePatterns = {
                zh: /[\u4e00-\u9fa5]/,      // 中文
                en: /[a-zA-Z]/,             // 英文
                th: /[\u0E00-\u0E7F]/,      // 泰语
                ja: /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/,  // 日语(平假名+片假名+汉字)
                ko: /[\uAC00-\uD7AF]/,      // 韩语
                ru: /[\u0400-\u04FF\u0500-\u052F]/,  // 俄语
                fr: /[éèêëçàâûîôùÉÈÊËÇÀÂÛÎÔÙ]/  // 法语
            };

            // 检测各语言的存在情况
            const detectedLanguages = {};
            for (const [lang, regex] of Object.entries(languagePatterns)) {
                detectedLanguages[lang] = regex.test(text);
            }

            // 统计各语言字符数量
            const charCounts = {};
            for (const [lang, regex] of Object.entries(languagePatterns)) {
                const matches = text.match(regex) || [];
                charCounts[lang] = matches.length;
            }

            // 特殊处理日语和中文的汉字重叠问题
            if (detectedLanguages.ja && detectedLanguages.zh) {
                // 如果同时检测到日语和中文，优先检查平假名/片假名
                const japaneseKana = text.match(/[\u3040-\u309F\u30A0-\u30FF]/g) || [];
                if (japaneseKana.length > 0) {
                    charCounts.ja += japaneseKana.length;
                } else {
                    // 如果没有平假名/片假名，则认为是中文
                    detectedLanguages.ja = false;
                }
            }

            // 找出检测到的语言
            const presentLanguages = Object.keys(detectedLanguages).filter(
                lang => detectedLanguages[lang]
            );

            // 根据检测结果返回语言代码
            if (presentLanguages.length === 0) {
                return 'unknown';
            } else if (presentLanguages.length === 1) {
                return presentLanguages[0];
            } else {
                // 多语言混合，返回字符数最多的语言
                let maxCount = 0;
                let dominantLang = 'unknown';

                for (const lang of presentLanguages) {
                    if (charCounts[lang] > maxCount) {
                        maxCount = charCounts[lang];
                        dominantLang = lang;
                    }
                }

                return dominantLang;
            }
        }
    },
}
</script>

<style scoped lang='scss'>
.BBox {
    padding: 10px;

    .title {
        font-weight: 600;
    }

    .commonBox {
        margin: 0 5px 5px 0;
        padding: 5px 10px;

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            pointer-events: none;
        }
    }
}
</style>